import DateTimeUtil from "../utils/dateTimeUtil";
import { PQ4castDataType } from "../models/metMap/pQ4castDataType";
class TrendLogic {
    static valueBy(t, kByDay, t0, t0Value) {
        const days = DateTimeUtil.diffDays(t0, t);
        return t0Value + kByDay * days;
    }
    static slopeRatio(yearRatio, dataType, withCutOff = false) {
        let yearCatastrophyLimit = NaN;
        switch (dataType) {
            case PQ4castDataType.Voltage:
                yearCatastrophyLimit = this.slopeLimit_VOLT;
                break;
            case PQ4castDataType.ThdU:
                yearCatastrophyLimit = this.slopeLimit_THDU;
                break;
            case PQ4castDataType.UnbU:
                yearCatastrophyLimit = this.slopeLimit_UNBU;
                break;
            case PQ4castDataType.Ptot:
                yearCatastrophyLimit = this.slopeLimit_PTOT;
                break;
            case PQ4castDataType.Qtot:
                yearCatastrophyLimit = this.slopeLimit_QTOT;
                break;
        }
        let slopeRatio = yearRatio / yearCatastrophyLimit;
        if (withCutOff)
            slopeRatio = Math.min(1, Math.max(-1, slopeRatio));
        return slopeRatio;
    }
    static alarmRatioSlope(yearRatio, dataType, withCutOff) {
        let slopeRatio = TrendLogic.slopeRatio(yearRatio, dataType, withCutOff);
        if (dataType === PQ4castDataType.Voltage) { //Qtot?
            slopeRatio = Math.abs(slopeRatio);
        }
        if (withCutOff)
            return Math.min(1, Math.max(0, slopeRatio));
        return slopeRatio;
    }
    static isShowTrends(mpoint, dataType) {
        const trend = mpoint.trends.get(dataType);
        return trend
            && DateTimeUtil.diffDays(trend.historyStart, trend.historyEnd) >= TrendLogic.minHistoryDays
            && TrendLogic.isTrendAlarm(mpoint, dataType);
    }
    static isTrendAlarm(mpoint, dataType) {
        return dataType === PQ4castDataType.Ptot ? mpoint.limits.pMax.enableTrendAlarm :
            dataType === PQ4castDataType.Qtot ? mpoint.limits.qMax.enableTrendAlarm :
                dataType === PQ4castDataType.Voltage ? mpoint.limits.uMax.enableTrendAlarm :
                    dataType === PQ4castDataType.ThdU ? mpoint.limits.thdMax.enableTrendAlarm :
                        dataType === PQ4castDataType.UnbU ? mpoint.limits.unbMax.enableTrendAlarm :
                            true;
    }
    static historyEndValue(trend) { return trend.channels[0].historyEndValue; }
    static kByDay(trend) { return trend.channels[0].kByDay; }
}
TrendLogic.slopeLimit_VOLT = .02;
TrendLogic.slopeLimit_THDU = .6;
TrendLogic.slopeLimit_UNBU = .6;
TrendLogic.slopeLimit_PTOT = .6;
TrendLogic.slopeLimit_QTOT = .6;
TrendLogic.minHistoryDays = NaN;
export default TrendLogic;
